export function filterActiveListings(listings = []) {
  const now = new Date();
  return listings.filter((item) => {
    if (!item.validTill) return true;
    return new Date(item.validTill) > now;
  });
}
